import { Howl } from 'howler';
import { soundsStore } from '@bg-shared/business/Sounds';
import { uaParser } from '@betgames/bg-tools';

export default class CasinoSoundsService {
    private readonly placeChipAudio = new Howl({
        src: ['/static/sounds/casino_place_chip.webm', '/static/sounds/casino_place_chip.mp3'],
        mute: soundsStore.gameSoundsMuted,
        html5: uaParser.isIOS, // in order to work in IOS silent mode
    });

    private readonly placeChipsAudio = new Howl({
        src: ['/static/sounds/casino_place_chips.webm', '/static/sounds/casino_place_chips.mp3'],
        mute: soundsStore.gameSoundsMuted,
        html5: uaParser.isIOS,
    });

    private readonly removeChipAudio = new Howl({
        src: ['/static/sounds/casino_remove_chip.webm', '/static/sounds/casino_remove_chip.mp3'],
        mute: soundsStore.gameSoundsMuted,
        html5: uaParser.isIOS,
    });

    private readonly trailingAudio = new Howl({
        src: ['/static/sounds/casino_trailing.webm', '/static/sounds/casino_trailing.mp3'],
        mute: soundsStore.gameSoundsMuted,
        html5: uaParser.isIOS,
    });

    constructor() {
        soundsStore.subscribe((state) => {
            this.placeChipAudio.mute(state.gameSoundsMuted);
            this.placeChipsAudio.mute(state.gameSoundsMuted);
            this.trailingAudio.mute(state.gameSoundsMuted);
            this.removeChipAudio.mute(state.gameSoundsMuted);
        });
    }

    public playPlaceChip(): void {
        this.placeChipAudio.play();
    }

    public playPlaceChips(): void {
        this.placeChipsAudio.play();
    }

    public playRemoveChip(): void {
        this.removeChipAudio.play();
    }

    public playTrailing(): void {
        this.trailingAudio.play();
    }

    public stop(): void {
        this.placeChipAudio.stop();
        this.placeChipsAudio.stop();
        this.removeChipAudio.stop();
        this.trailingAudio.stop();
    }
}

export const casinoSoundsService = new CasinoSoundsService();
